import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; // Importa CommonModule
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-contacts',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.css'
})
export class ContactsComponent {

}
